// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoChip_root__1689C","title":"InfoChip_title__16ifw","description":"InfoChip_description__gKrml"};